export const bgColors: Record<string, string> = {
  createdToday: 'var(--blue-500)',
  created: 'var(--blue-400)',

  collected: 'var(--cyan-300)',
  collectedToday: 'var(--cyan-500)',
  collectedOfToday: 'var(--cyan-700)',

  delivered: 'var(--pink-300)',
  deliveredToday: 'var(--pink-500)',

  deliveredByTheCourier: 'var(--teal-300)',
  deliveredByTheCourierOfToday: 'var(--teal-500)',
  deliveredByTheCourierToday: 'var(--teal-600)',
  pendingPickupByTheCourier: 'var(--teal-700)',
  pendingPickupByTheCourierOfToday: 'var(--teal-900)',

  collectedByTheRecipientFromHub: 'var(--yellow-300)',
  collectedByTheRecipientFromHubToday: 'var(--yellow-500)',
  // collectedByTheRecipientFromHubOfToday: 'var(--yellow-700)',

  pendingSelfCarryingToHub: 'var(--purple-300)',
  pendingSelfCarryingToHubOfToday: 'var(--purple-500)',
  pendingSelfPickupFromHub: 'var(--purple-700)',
  pendingSelfPickupFromHubOfToday: 'var(--purple-900)',

  inPickupHub: 'var(--indigo-300)',
  inSortingCenter: 'var(--indigo-500)',
  inDeliveryHub: 'var(--indigo-700)',

  transferToHub: 'var(--bluegray-300)',
  transferToSortingCenter: 'var(--bluegray-500)',
  outForDelivery: 'var(--bluegray-700)',
  outForDeliveryToday: 'var(--bluegray-800)',

  unsuccessfulDeliveryAttempt: 'var(--red-300)',
  rejectedByTheRecipient: 'var(--red-400)',
  returnInitiated: 'var(--red-500)',
  returnInitiatedToday: 'var(--red-600)',
  returnedToday: 'var(--red-700)',
  returned: 'var(--red-800)',
};
